var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "label-tree",
    },
    [
      _vm.isShowCheckbox
        ? _c("el-input", {
            staticClass: "filter-text",
            attrs: {
              placeholder: "请输入关键字进行查询",
              "prefix-icon": "el-icon-search",
            },
            model: {
              value: _vm.filterText,
              callback: function ($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText",
            },
          })
        : _vm._e(),
      _c("el-tree", {
        ref: "tree",
        class: [
          { "edit-program": _vm.treeData[0].isEdit },
          { "edit-diy": _vm.treeData[1].isEdit },
        ],
        attrs: {
          data: _vm.treeData,
          props: { label: "name", children: "tagList" },
          "show-checkbox": _vm.isShowCheckbox,
          "filter-node-method": _vm.filterNode,
          "node-key": "id",
          "highlight-current": "",
          "default-expanded-keys": [1, 2],
          "default-expand-all": false,
          "expand-on-click-node": false,
        },
        on: { check: _vm.addLabel },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ node, data, $index }) {
              return _c("span", { staticClass: "custom-tree-node" }, [
                node.level === 3
                  ? _c(
                      "label",
                      {
                        class: [
                          {
                            "label-disable":
                              data.status === 2 && _vm.typeStr != "typePage",
                          },
                        ],
                        attrs: { title: node.label },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                query: {
                                  ..._vm.$route.query,
                                  labelId: data.id,
                                  type: "label",
                                },
                              },
                            },
                          },
                          [_vm._v(_vm._s(node.label))]
                        ),
                      ],
                      1
                    )
                  : _c("label", { attrs: { title: node.label } }, [
                      _vm._v(_vm._s(node.label)),
                      node.level === 2 && data.tagList.length !== 0
                        ? _c("span", [
                            _vm._v(
                              " (" +
                                _vm._s(
                                  _vm.typeStr == "typePage"
                                    ? data.tierList.length
                                    : data.tagList.length
                                ) +
                                ")"
                            ),
                          ])
                        : _vm._e(),
                    ]),
                _vm.isShowCheckbox
                  ? _c(
                      "span",
                      { staticClass: "operation select-num" },
                      [
                        node.level === 1
                          ? _c(
                              "el-badge",
                              {
                                attrs: {
                                  value: _vm.selectNum,
                                  type: "primary",
                                },
                              },
                              [_vm._v("已选")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c(
                      "span",
                      { staticClass: "operation" },
                      [
                        node.level === 1
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: () =>
                                      _vm.onOperationType("edit", data),
                                  },
                                },
                                [_vm._v(_vm._s(data.isEdit ? "取消" : "编辑"))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: () =>
                                      _vm.onOperationType("add", data),
                                  },
                                },
                                [_vm._v("新增分类")]
                              ),
                            ]
                          : node.level === 2
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: () =>
                                      _vm.onOperationType("rename", data),
                                  },
                                },
                                [_vm._v("重命名")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: () =>
                                      _vm.onOperationType("delete", data),
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          : [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: () =>
                                      _vm.onOperationType("move", data, 0),
                                  },
                                },
                                [_vm._v("移动")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: () =>
                                      _vm.onOperationType("renameLabel", data),
                                  },
                                },
                                [_vm._v("重命名")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: () =>
                                      _vm.onOperationType("deleteLabel", data),
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                      ],
                      2
                    ),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }